/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Badge, Loader } from '@livechat/design-system'

import MarkdownRenderer from '../MarkdownRenderer'

const Pending = ({ surveyId, structure }) => {
  return [1, 2].map(({}, answerIndex) => {
    return (
      <div
        className="visitor-response"
        key={`${surveyId}-detailed-loading-${answerIndex}`}
      >
        <div>
          <Badge>{answerIndex + 1}</Badge>
          <span className="divider" />
        </div>
        {structure.map((field, fieldIndex) => {
          return (
            <div
              key={`${surveyId}-detailed-loading-${answerIndex}-${fieldIndex}`}
              className="field"
            >
              <div className="question">
                <MarkdownRenderer>{field.question}</MarkdownRenderer>
              </div>
              <div className="answer">
                <Loader className="loader" />
              </div>
            </div>
          )
        })}
      </div>
    )
  })
}

export default Pending
